import { engineComponent } from "neo-common";
import { Controller } from "../Controller";
import { BaseModel } from "./BaseModel";
import { BaseView } from "./BaseView";
import { ComponentTypes } from "../../Components/ComponentTypes";

@engineComponent(ComponentTypes.Controller)
export class BaseController extends Controller {
    public static readonly SpinReceived: string = "eventSpinReceived";
    public static readonly MachineStopped: string = "eventMachineStopped";
    public static readonly WinCalculationFinished: string = "eventWinCalculationFinished";
    public static readonly AllWinsFinished: string = "eventAllWinsFinished";
    public static readonly IntroFinished: string = "eventIntroFinished";
    public static readonly OutroFinished: string = "eventOutroFinished";
    public static readonly QuickWinCalculationFinished: string = "eventQuickWinCalculationFinished";

    protected _view: BaseView;
    protected _model: BaseModel;

    constructor() {
        super();
    }

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof BaseView) {
            this._view = view;
        } else {
            if (DEBUG) {
                this.log("ERROR view is not instance of BaseView");
            }
        }

        this._model = new BaseModel(this);
    }

    initReceived(): void {
        this._view.initReceived(this);
    }

    disableLogo(): void {
        this._view.disableLogo();
    }

    initIntro(): void {
        this._view.initIntro();
    }

    collect(): void {
        this._view.collect();
    }

    spin(): void {
        this._model.spin();
        this._view.spin();
    }

    stop(): void {
        this._view.stop();
    }

    spinReceived(): void {
        this._view.spinReceived();
        this.emit(BaseController.SpinReceived);
    }

    machineStopped(): void {
        this.emit(BaseController.MachineStopped);
    }

    quickWinCalculationFinished(): void {
        this.emit(BaseController.QuickWinCalculationFinished);
    }

    winCalculationFinished(): void {
        this.emit(BaseController.WinCalculationFinished);
    }

    allWinsFinished(): void {
        this.emit(BaseController.AllWinsFinished);
    }

    resetWinAnimator(): void {
        this._view.resetWinAnimator();
    }

    intro(long: boolean = false): void {
        this._view.intro(long);
    }

    introFinished(): void {
        this.emit(BaseController.IntroFinished);
    }

    outro(): void {
        this._view.outro();
    }

    outroFinished(): void {
        this.emit(BaseController.OutroFinished);
    }

    selectPayline(): void {
        this._view.selectPayline();
    }

    setIsDesktopChannel(isDesktopChannel: boolean = false): void {
        this._view.setIsDesktopChannel(isDesktopChannel);
    }

    disableBase(): void {
        this._view.disableBase();
    }

    toggleSounds(enable: boolean): void {
        this._view.toggleSounds(enable);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Base/BaseController.ts
 **/